import dayjs from "dayjs";

import { getFileName } from "../../utils/Helpers";

export const REQUEST_TABS = {
  pending: "pending",
  done: "done",
};

export const REQUEST_TYPES = {
  publish: "publish",
  crewSizeChange: "upgrade_size",
};

export const REQUEST_STATUSES = {
  pending: "pending",
  accepted: "accepted",
  rejected: "rejected",
  cancelled: "canceled",
};

export const EMPTY_REQUEST_FILTERS = {
  search: "",
  company: null,
  type: null,
  date: null,
  status: null,
};

export const fillTemplate = (template = "", values = {}) =>
  Object.keys(values).reduce(
    (text, key) => text.split(`{${key}}`).join(values[key]),
    template,
  );

export const formatAmount =(value) => Number(value || 0).toLocaleString("en-US");

export const getCompanyName = (company, lang) =>
  (lang === "ar"
    ? company?.name_ar || company?.name_en
    : company?.name_en || company?.name_ar) || "";

export const hasActiveFilters = (filters) =>
  Boolean(
    filters.search.trim() ||
      filters.company ||
      filters.type ||
      filters.date ||
      filters.status,
  );

const DONE_STATUSES = [
  REQUEST_STATUSES.accepted,
  REQUEST_STATUSES.rejected,
  REQUEST_STATUSES.cancelled,
];

/**
 * Query of the requests list (PROLINE-4025). The tabs are a `status` filter. Both tabs
 * list the most recent request first (answer on PROLINE-3992, the API's default).
 */
export const buildRequestsParams = ({ tab, filters, search, page, pageSize }) => {
  const isPendingTab = tab === REQUEST_TABS.pending;
  const params = {
    status: isPendingTab
      ? REQUEST_STATUSES.pending
      : filters.status?.id ?? DONE_STATUSES.join(","),
    order_by_created_at: "desc",
    page,
    items: pageSize,
  };
  if (search) params.query = search;
  if (filters.company) params.company_id = filters.company.id;
  if (filters.type) params.request_type = filters.type.id;
  if (filters.date) {
    const date = dayjs(filters.date).format("YYYY-MM-DD");
    params.created_at_start_date = date;
    params.created_at_end_date = date;
  }
  return params;
};

/** The backend stores the upload as `<uuid>-<original name>`. */
const STORED_NAME_PREFIX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

/** The name the company gave the file, as the stored link carries it (PROLINE-4179). */
export const getPaymentProofName = (url) => {
  const name = getFileName(url.split("?")[0]);
  let decoded = name;
  try {
    decoded = decodeURIComponent(name);
  } catch {
    // A malformed escape: keep the name as stored.
  }
  return decoded.replace(STORED_NAME_PREFIX, "");
};

/**
 * A payment request of the API as the table and the popups read it. The crew size is
 * only on the detailed request (`show`); a custom plan keeps its size on the event.
 */
export const mapPaymentRequest = (request) => {
  const plan = request.crew_size_plan;
  return {
    id: request.id,
    type: request.request_type,
    status: request.status,
    company: request.company,
    event: request.event,
    amount: Number(request.total_amount) || 0,
    requested_at: request.created_at,
    payment_proof: request.payment_proof_url
      ? {
          name: getPaymentProofName(request.payment_proof_url),
          url: request.payment_proof_url,
        }
      : null,
    crewSize: plan
      ? {
          name: plan.name,
          min: plan.custom ? null : plan.min_size,
          max: plan.custom ? request.event?.custom_crew_size : plan.max_size,
        }
      : null,
    currentCrewSizeName: request.event?.crew_size_plan?.name,
  };
};
